import * as styles from '@layouts/HomeLayout.module.scss';
import * as React from 'react';
export default {
  styles,
  React
};